(function () {
  // Warenkorb in den Abschnitt „Warenkorb“ haengen (Klick in der Editor-Vorschau waehlt den Abschnitt)
  var gemerkt = { d: null, h: null };
  function einhaengen() {
    var a = document.getElementById('nd-warenkorb-anker');
    var d = document.getElementById('cart-drawer') || gemerkt.d;
    var h = document.querySelector('.cart-backdrop') || gemerkt.h;
    if (d) gemerkt.d = d;
    if (h) gemerkt.h = h;
    var ziel = a || document.body;
    if (h && h.parentNode !== ziel) ziel.appendChild(h);
    if (d && d.parentNode !== ziel) ziel.appendChild(d);
  }
  var laeuft = false;
  function pruefen() {
    if (laeuft) return; laeuft = true;
    setTimeout(function () { laeuft = false; einhaengen(); }, 0);
  }
  function start() {
    einhaengen();
    if (window.MutationObserver) new MutationObserver(function () {
      var a = document.getElementById('nd-warenkorb-anker');
      var d = gemerkt.d || document.getElementById('cart-drawer');
      if (!d || !d.isConnected || (a && d.parentNode !== a)) pruefen();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  if (!(window.Shopify && Shopify.designMode)) return;
  function istWk(e) { return e.target && e.target.querySelector && e.target.querySelector('#nd-warenkorb-anker'); }
  document.addEventListener('shopify:section:load', function (e) { if (istWk(e)) einhaengen(); });
  document.addEventListener('shopify:section:select', function (e) {
    if (istWk(e) && window.NadosCart && window.NadosCart.open) window.NadosCart.open(false);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var docked = window.NadosCart && window.NadosCart.docked && window.NadosCart.docked();
    if (istWk(e) && !docked && window.NadosCart && window.NadosCart.close) window.NadosCart.close();
  });
})();
;
(function () {
  function minimum() {
    var m = parseFloat(String((window.NadosTexte || {}).__liefer_min == null ? '' : window.NadosTexte.__liefer_min).replace(',', '.'));
    return isNaN(m) ? 0 : m;
  }
  function zahl(t) {
    t = String(t || '').replace(/[^0-9,.\-]/g, '');
    if (t.indexOf(',') !== -1) t = t.replace(/\./g, '').replace(',', '.');
    var n = parseFloat(t); return isNaN(n) ? null : n;
  }
  function summe() {
    var s = 0;
    Array.prototype.forEach.call(document.querySelectorAll('#cart-drawer .cart-item-row'), function (r) {
      var p = r.querySelector('.cart-item-preis');   // v2.78: Zeilenpreis (Preis x Menge)
      var n = zahl(p ? p.textContent : '');
      if (n !== null) s += n;
    });
    return s;
  }
  function lieferung() {
    var a = document.querySelector('.fulfillment-option.active');
    return !!(a && a.getAttribute('data-fulfillment') === 'lieferung');
  }
  function gesperrt() { var min = minimum(); return min > 0 && lieferung() && summe() < min - 0.001; }
  function anzeigen() {
    var k = document.querySelector('#cart-drawer .cart-kasse');
    if (!k) return;
    var g = gesperrt();
    if (k.classList.contains('nd-gesperrt') !== g) k.classList.toggle('nd-gesperrt', g);
    if (k.getAttribute('aria-disabled') !== String(g)) k.setAttribute('aria-disabled', String(g));
  }
  function wackeln() {
    var i = document.querySelector('#cart-drawer .cart-info');
    if (!i) return;
    i.classList.remove('nd-wackeln'); void i.offsetWidth; i.classList.add('nd-wackeln');
  }
  // Fenster-Capture laeuft vor allen anderen Klick-Behandlungen von „Zur Kasse“
  window.addEventListener('click', function (e) {
    var k = e.target && e.target.closest ? e.target.closest('#cart-drawer .cart-kasse') : null;
    if (!k || !gesperrt()) return;
    e.preventDefault(); e.stopPropagation();
    anzeigen(); wackeln();
  }, true);
  document.addEventListener('click', function () { setTimeout(anzeigen, 0); setTimeout(anzeigen, 400); }, true);
  var warten = false;
  function start() {
    anzeigen();
    if (window.MutationObserver) new MutationObserver(function () {
      if (warten) return; warten = true;
      setTimeout(function () { warten = false; anzeigen(); }, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.NadosLieferMinimum = { gesperrt: gesperrt, summe: summe };
})();
;
(function () {
  // Box-Karten, die erst spaeter erscheinen (Theme-Editor laedt den Abschnitt neu), per Delegation oeffnen
  Array.prototype.forEach.call(document.querySelectorAll('.box-card'), function (c) { c.__ndGebunden = true; });
  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.box-card') : null;
    if (!card || card.__ndGebunden || card.classList.contains('is-soldout') || !window.NadosBox) return;
    var a = document.querySelector('.fulfillment-option.active');
    var modus = a ? a.getAttribute('data-fulfillment') : 'abholung';
    var d = document.getElementById('abholdatum'), z = document.getElementById('abholuhrzeit');
    if (!(d && d.value && z && z.value)) {
      var f = document.getElementById('abholung-fields');
      if (f && f.scrollIntoView) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var fehlt = (d && !d.value) ? d : z;
      if (fehlt) { fehlt.classList.add('field-error'); fehlt.classList.remove('field-shake'); void fehlt.offsetWidth; fehlt.classList.add('field-shake'); }
      return;
    }
    window.NadosBox.open(card);
  });
  // Bestell-Eigenschaft „Lieferung“ mit dem eingestellten Mindestbestellwert
  var alt = window.NadosFulfillmentProps;
  if (typeof alt === 'function') window.NadosFulfillmentProps = function () {
    var p = alt.apply(this, arguments) || {};
    if (p['Lieferung']) {
      var m = (window.NadosTexte || {}).__liefer_min;
      p['Lieferung'] = (m && Number(m) > 0) ? 'Ja (Mindestbestellwert ' + m + ' €, im Warenkorb geprueft)' : 'Ja';
    }
    return p;
  };
})();
;
(function () {
  // Bestand je Sorte (data-bestand am Sorten-Element; leer = unbegrenzt)
  var aktiv = null;
  document.addEventListener('click', function (e) { var c = e.target && e.target.closest ? e.target.closest('.box-card') : null; if (c) { aktiv = c; setTimeout(leerHinweis, 30); } }, true);
  // Box ohne Sorten: Hinweis im Box-Fenster
  function leerHinweis() {
    var liste = document.getElementById('flavour-list'), m = document.getElementById('box-modal');
    if (!liste || !m || m.hidden || liste.children.length) return;
    var en = window.NadosI18n && window.NadosI18n.get && window.NadosI18n.get() === 'en';
    var li = document.createElement('li'); li.className = 'flavour-row nd-leer';
    li.textContent = en ? 'No flavours have been added to this box yet.' : 'Für diese Box sind noch keine Sorten hinterlegt.';
    liste.appendChild(li);
  }
  function quellen(karte) {
    var q = (karte || aktiv) && (karte || aktiv).querySelector('.nd-sorten');
    return (q || document.getElementById('flavour-source') || document).querySelectorAll('.flavour-src');
  }
  function bestand(i, karte) {
    var q = quellen(karte)[i];
    var b = q ? q.getAttribute('data-bestand') : null;
    if (b === null || b === '') return Infinity;
    var n = parseInt(b, 10); return isNaN(n) ? Infinity : Math.max(n, 0);
  }
  function bestandNachName(name, karte) {
    var qs = quellen(karte);
    for (var i = 0; i < qs.length; i++) if (qs[i].getAttribute('data-name') === name) return bestand(i, karte);
    return Infinity;
  }
  function anzahlBoxen() { var v = document.getElementById('box-qty-val'); return parseInt(v ? v.textContent : '1', 10) || 1; }
  function begrenzen() {
    var liste = document.getElementById('flavour-list');
    if (!liste) return;
    var zeilen = liste.children, qty = anzahlBoxen(), plusBoxen = true;
    var en = window.NadosI18n && window.NadosI18n.get && window.NadosI18n.get() === 'en';
    for (var i = 0; i < zeilen.length; i++) {
      var max = bestand(i), r = zeilen[i];
      var n = parseInt((r.querySelector('.q-val') || {}).textContent || '0', 10) || 0;
      var aus = max <= 0;
      r.classList.toggle('nd-aus', aus);
      var t = r.querySelector('.nd-aus-text');
      if (aus && !t) { t = document.createElement('span'); t.className = 'nd-aus-text'; (r.querySelector('.flavour-name') || r).appendChild(t); }
      if (t) t.textContent = aus ? (en ? 'sold out' : 'ausverkauft') : '';
      var plus = r.querySelector('.q-plus');
      if (plus && (n + 1) * qty > max) plus.disabled = true;
      if (n > 0 && n * (qty + 1) > max) plusBoxen = false;
    }
    var bp = document.getElementById('box-qty-plus');
    if (bp && !plusBoxen) bp.disabled = true; else if (bp) bp.disabled = false;
  }
  // Klicks auf gesperrte Knoepfe abfangen (laeuft vor dem Box-Fenster)
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('#flavour-list .q-plus, #box-qty-plus') : null;
    if (b && b.disabled) { e.stopPropagation(); e.preventDefault(); return; }
    if (e.target && e.target.closest && e.target.closest('#box-modal')) setTimeout(begrenzen, 0);
  }, true);
  // Feste Boxen: grau, wenn eine enthaltene Sorte nicht reicht
  function festeBoxenPruefen() {
    Array.prototype.forEach.call(document.querySelectorAll('.box-card[data-inhalt]'), function (karte) {
      var inhalt = karte.getAttribute('data-inhalt') || '', fehlt = false;
      inhalt.split(',').forEach(function (teil) {
        var m = /^\s*(.+?)\s*:\s*(\d+)\s*$/.exec(teil);
        if (m && parseInt(m[2], 10) > bestandNachName(m[1], karte)) fehlt = true;
      });
      if (fehlt) karte.classList.add('is-soldout', 'nd-sorte-fehlt');
      else if (karte.classList.contains('nd-sorte-fehlt')) karte.classList.remove('is-soldout', 'nd-sorte-fehlt');
    });
  }
  // Feste Boxen ohne eigene Kollektion: Standard-Sorten gleichmaessig verteilen
  function standardInhalt() {
    var namen = Array.prototype.map.call(document.querySelectorAll('#flavour-source .flavour-src'), function (n) { return n.getAttribute('data-name') || ''; }).filter(Boolean);
    if (!namen.length) return;
    Array.prototype.forEach.call(document.querySelectorAll('.box-card[data-fest]:not([data-inhalt])'), function (karte) {
      var g = parseInt(karte.getAttribute('data-box-size'), 10) || 0, n = namen.length, teile = [];
      for (var i = 0; i < n; i++) { var k = Math.floor(g / n) + (i < g % n ? 1 : 0); if (k > 0) teile.push(namen[i] + ':' + k); }
      if (teile.length) karte.setAttribute('data-inhalt', teile.join(', '));
    });
  }
  function start() {
    standardInhalt();
    festeBoxenPruefen();
    var liste = document.getElementById('flavour-list');
    if (liste && window.MutationObserver) new MutationObserver(function () { begrenzen(); }).observe(liste, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', function () { setTimeout(start, 0); });
  window.NadosBestand = { begrenzen: begrenzen, pruefen: festeBoxenPruefen };
})();
;
(function () {
  // Das „+“ ist das ::after-Element unten rechts im Kartenbild – Klickflaeche daraus berechnen
  function plusFlaeche(e, media) {
    var r = media.getBoundingClientRect(), cs = window.getComputedStyle(media, '::after');
    var w = parseFloat(cs.width) || 34, h = parseFloat(cs.height) || 34;
    var ri = parseFloat(cs.right), bo = parseFloat(cs.bottom);
    if (isNaN(ri)) ri = 8; if (isNaN(bo)) bo = 8;
    var x = r.right - ri - w, y = r.bottom - bo - h;
    if (e.clientX < x - 4 || e.clientX > x + w + 4 || e.clientY < y - 4 || e.clientY > y + h + 4) return null;
    return { left: x, top: y, width: w, height: h, right: x + w, bottom: y + h };
  }
  window.addEventListener('click', function (e) {
    var karte = e.target && e.target.closest ? e.target.closest('.box-card') : null;
    if (!karte || !window.NadosCart || !window.NadosCart.addBox) return;
    var media = karte.querySelector('.box-card-media');
    if (!media || !media.contains(e.target)) return;
    var flaeche = plusFlaeche(e, media);
    if (!flaeche) return;
    if (!karte.hasAttribute('data-fest') || !karte.getAttribute('data-teile')) return;   // selbst waehlen: Box-Fenster wie bisher
    if (karte.classList.contains('is-soldout')) return;
    var a = document.querySelector('.fulfillment-option.active');
    var modus = a ? a.getAttribute('data-fulfillment') : 'abholung';
    var d = document.getElementById('abholdatum'), z = document.getElementById('abholuhrzeit');
    if (!(d && d.value && z && z.value)) return;                  // Hinweis auf Abholtermin wie bisher
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (window.NadosCart.fly) window.NadosCart.fly({ getBoundingClientRect: function () { return flaeche; } });
    var props = window.NadosFulfillmentProps ? window.NadosFulfillmentProps() : {};
    window.NadosCart.addBox(window.NadosCart.boxFromCard(karte, 1, props));
  }, true);
})();
